var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStockx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    id: "Stockx--Streamline-Simple-Icons",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Stockx Streamline Icon: https://streamlinehq.com\n  ")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "StockX") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.74 16.5 22.5 24v-6l-7 -6 7 -6V0L10.26 10.5v-3L1.5 0v6l7 6 -7 6v6l12.24 -10.5Z",
    fill: "#000000",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockx);
export default __webpack_public_path__ + "static/media/stockx.f3885a116e2488655626fbbd26c7067b.svg";
export { ForwardRef as ReactComponent };